function getHeight() {
  var h = Math.max(
    document.documentElement.clientHeight,
    window.innerHeight || 0
  );
  return h;
}

export { getHeight };
